document.addEventListener("DOMContentLoaded", function () {
  
  // LAZY VÍDEOS HOME
  const lazyVideos = document.querySelectorAll('.lazy-video');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const videoId = el.dataset.videoId;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&playsinline=1&rel=0&modestbranding=1&showinfo=0&loop=1&playlist=${videoId}`;
        iframe.allow = "autoplay; encrypted-media";
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');

        // Substitui o conteúdo
        el.innerHTML = '';
        el.appendChild(iframe);

        observer.unobserve(el);
      }
    });
  }, {
    threshold: 0.25
  });

  lazyVideos.forEach(video => {
    observer.observe(video);

    const button = video.querySelector('.play-button');
    if (button) {
      button.addEventListener('click', () => {
        const videoId = video.dataset.videoId;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&playsinline=1&rel=0&modestbranding=1&showinfo=0&loop=1&playlist=${videoId}`;
        iframe.allow = "autoplay; encrypted-media";
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');

        video.innerHTML = '';
        video.appendChild(iframe);
      });
    }
  });
});


(function waitForJQuery(){
  if (typeof window.jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    initMenuMobile();
    initCarousel();
  } else {
    setTimeout(waitForJQuery, 50);
  }
})();

function initCarousel() {
  jQuery(function($){
    $('.carousel-reviews').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 992,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: 576,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });

    $('.carousel-reviews').on('setPosition', function () {
      if (window.AOS) AOS.refresh();
    });
  });
}






// HEADER
jQuery("document").ready(function($){
    var nav = $('.header-lp');
    $(window).scroll(function () {
        if ($(this).scrollTop() > 30) {
            nav.addClass("header-fixed");
        } else {
            nav.removeClass("header-fixed");
        }
    });
});



// MENU MOBILE
function initMenuMobile(){
  jQuery(document).ready(function(){
    jQuery('#menu-menu-principal').clone().appendTo('#menuMobile .menuNav');
  });
}

jQuery(document).on("click", ".open-menu", function(){
  jQuery('#menuMobile').addClass('menuOpened');
  jQuery('.overlay-menu').show().addClass('overlayMenu');
  jQuery('body').css('overflow-y','hidden')
});

jQuery(document).on("click", ".overlayMenu", function(){
  jQuery('#menuMobile').removeClass('menuOpened');
  jQuery('.overlay-menu').hide().removeClass('overlayMenu');
  jQuery('body').css('overflow-y','auto')
});

jQuery(document).on("click", "#menuMobile .navbar-nav .nav-link", function() {
  jQuery('#menuMobile').removeClass('menuOpened');
  jQuery('.overlay-menu').hide().removeClass('overlayMenu');
  jQuery('body').css('overflow-y','auto')
})